export default {
  area: '积分商城',
  objectName: '积分商城',
  //url
  // https://mall.anluoyun.cn/prod-api/
  // http://hotelapi.zhsq.cloud/
  hostUrl: 'https://yyjp.zhsq.cloud',
  apiHttpsUrl: 'https://mall.anluoyun.cn/prod-api/',
  apiRequestUrl: 'https://mall.anluoyun.cn/prod-api/',
  apiUploadUrl: 'https://mall.anluoyun.cn/prod-api/common/OssUploadImg',
  apiUploadFiles:
    'https://mall.anluoyun.cn/prod-api/api/UploadFile/UploadImgOrFile',
}
